export default __webpack_public_path__ + "static/media/frame_en_pc@2x.4417da2a.png";